module.exports = __webpack_public_path__ + "static/img/big1.705fcf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/district/assets/image/home/big1.png
// module id = iIpk
// module chunks = 3